import type { LocationQueryRaw, RouteLocation } from "vue-router";
import type { IAuth } from "./auth";

export default defineNuxtPlugin(() => {
  const redirectToLogin = (currentRoute?: RouteLocation) => {
    const app = useNuxtApp();
    if (!(app.$auth as IAuth).loggedIn) {
      const router = useRouter();
      const query = {} as LocationQueryRaw;
      const _route = currentRoute || useRoute();
      if (_route.path !== "/") {
        query.next = _route.path;
      }
      return router.replace({ path: "/login", query });
    }
  };

  return {
    provide: {
      redirectToLogin,
    },
  };
});
